import React from 'react';
import Header from '@/components/shared/Header';
import Footer from '@/components/shared/Footer';
import Chatbot from '@/components/shared/Chatbot';

const OnlineCoursesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="max-w-7xl mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold mb-6">Online Courses</h1>
        <p>Browse and purchase online courses here.</p>
      </div>
      <Footer />
      <Chatbot />
    </div>
  );
};

export default OnlineCoursesPage;
